import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import React, { Component } from "react";
import {
    Container,
    Button,
    Col,
    Card,
    CardBody,
    CardTitle,
} from "reactstrap"
import { Link } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { withRouter } from "../../components/Common/withRouter"
import CampaignChargeEditForm from "./CampaignChargeEditForm";

// Utilities
import {
    createNotificationHelpers,
    updateCampaignCharges,
} from "../utils";

class CampaignChargeEdit extends Component {
    constructor(props) {
        super(props)
        this.state = {
            store_domain: "",
            campaign_variable_charge: 2,
            campaign_fixed_charge: 0,
            loading: false,
            store_details: props.location?.state?.data?.store_details || {},
            store_status: "",
        }

        // Initialize notification helpers
        const notifications = createNotificationHelpers();
        this.notify_error = notifications.notify_error;
        this.notify_success = notifications.notify_success;
    }
    componentDidMount() {
        const locationState = this.props.location?.state;
        const data = locationState?.data || this.props.location?.data;
        if (data && data.store_domain) {
            const { store_domain, campaign_variable_charge, campaign_fixed_charge, store_details, store_status } = data;
            this.setState({
                store_domain,
                campaign_variable_charge: Number(campaign_variable_charge),
                campaign_fixed_charge: Number(campaign_fixed_charge),
                store_details: { ...store_details },
                store_status
            });
            return;
        }
        const params = new URLSearchParams(this.props.location?.search || '');
        const storeFromQuery = params.get('store');
        if (storeFromQuery) {
            this.setState({ store_domain: storeFromQuery });
        }
    }
    /**
     * Handles form submission
     */
    handleValidSubmit = async (e) => {
        e.preventDefault();
        const { store_domain, campaign_variable_charge, campaign_fixed_charge } = this.state;

        const success = await updateCampaignCharges(
            store_domain,
            campaign_variable_charge,
            campaign_fixed_charge,
            this.notify_error
        );

        if (success) {
            this.setState({ loading: true });
            this.notify_success("Campaign Usage Charge has been updated successfully!");
        }
    }

    handleInputChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    render() {
        const { store_domain, store_details, store_status, campaign_variable_charge, campaign_fixed_charge, loading } = this.state;
        return (
            <React.Fragment>
                <div className="page-content">
                    <Helmet>
                        <title>Veeper | AP - Campaign Usage Charge Edit</title>
                    </Helmet>
                    <Container fluid>
                        <Breadcrumbs
                            title={("Campaign Usage Charge Edit")}
                            breadcrumbItem={("Chare Edit")}
                        />
                        <ToastContainer />
                        <Col md={12}>
                            <Card>
                                <CardBody>
                                    <CardTitle className="h4"></CardTitle>
                                    <Link to={{ pathname: "/merchant-details", search: store_domain ? `?store=${encodeURIComponent(store_domain)}` : undefined, state: { data: (store_details && Object.keys(store_details).length > 0) ? store_details : { store_domain }, storeStatus: store_status } }} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                        <Button className="btn btn-dark">
                                            <i className="fa fa-arrow-left"></i> Store Details
                                        </Button>
                                    </Link>

                                    <CampaignChargeEditForm
                                        store_domain={store_domain}
                                        campaign_variable_charge={campaign_variable_charge}
                                        campaign_fixed_charge={campaign_fixed_charge}
                                        onInputChange={this.handleInputChange}
                                        onSubmit={this.handleValidSubmit}
                                    />
                                </CardBody>
                            </Card>
                        </Col>

                    </Container>
                </div>
            </React.Fragment>
        )
    }
}

CampaignChargeEdit.propTypes = {
    t: PropTypes.any
}
export default withRouter(CampaignChargeEdit)
